import React from "react";
import { ChefHat, Shirt, Sofa, Hammer, Building2, PencilRuler } from "lucide-react";

const SERVICES = [
  {
    id: "modular-kitchen",
    Icon: ChefHat,
    title: "Modular Kitchens",
    body: "Tailored layouts, premium hardware, German hinges and a 10-year warranty on carcass.",
  },
  {
    id: "wardrobes",
    Icon: Shirt,
    title: "Bedroom Wardrobes",
    body: "Sliding, hinged and walk-in wardrobes — laminate, veneer, lacquered glass and PU finishes.",
  },
  {
    id: "living",
    Icon: Sofa,
    title: "Living & Dining",
    body: "TV units, false ceilings, bespoke joinery and lighting plans for everyday luxury.",
  },
  {
    id: "turnkey",
    Icon: Building2,
    title: "Turnkey Interiors",
    body: "Single-window execution from civil and electricals to final styling — on time, on budget.",
  },
  {
    id: "renovation",
    Icon: Hammer,
    title: "Renovation",
    body: "Refresh a kitchen, a bedroom or a whole apartment — minimal disruption, premium finish.",
  },
  {
    id: "consulting",
    Icon: PencilRuler,
    title: "Design Consulting",
    body: "Floor plans, 3D walkthroughs and material curation — perfect for self-managed projects.",
  },
];

const Services = () => (
  <section
    id="services"
    className="relative bg-[#F7F5F0] text-[#0A0A0A]"
    data-testid="services-section"
  >
    <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12 md:py-32">
      <div className="grid items-end gap-6 md:grid-cols-12">
        <div className="md:col-span-7">
          <span className="text-[10px] uppercase tracking-[0.32em] text-[#0A0A0A]/55">03 · Services</span>
          <h2 className="mt-4 font-[Cormorant_Garamond] text-4xl font-light leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
            From a single<br /> wardrobe to a <span className="italic text-[#B8996F]">whole home.</span>
          </h2>
        </div>
        <div className="md:col-span-5">
          <p className="font-[Outfit] text-base leading-relaxed text-[#0A0A0A]/70">
            We work across modular, civil and styling — under one roof. Every project goes through the same studio
            quality control, regardless of scope.
          </p>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 border border-[#0A0A0A]/10 md:grid-cols-3">
        {SERVICES.map(({ id, Icon, title, body }, i) => (
          <div
            key={id}
            data-testid={`service-card-${id}`}
            className={`group relative flex flex-col gap-4 border-[#0A0A0A]/10 bg-[#F7F5F0] p-8 transition-colors duration-300 hover:bg-[#EAE6DF] md:p-10
              ${i % 3 !== 2 ? "md:border-r" : ""}
              ${i < 3 ? "md:border-b" : ""}
              ${i !== SERVICES.length - 1 ? "border-b md:border-b-0" : ""}
            `}
          >
            <div className="flex items-center gap-3">
              <Icon size={22} strokeWidth={1.4} className="text-[#B8996F]" />
              <span className="text-[10px] uppercase tracking-[0.24em] text-[#0A0A0A]/45">
                0{i + 1}
              </span>
            </div>
            <h3 className="font-[Cormorant_Garamond] text-3xl font-light leading-tight">{title}</h3>
            <p className="font-[Outfit] text-sm leading-relaxed text-[#0A0A0A]/70">{body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
